import React from "react";


const SubSpecialtyCard = ({subSpecialty}) => {
    return (

        <label className="tag-widget">{subSpecialty.name}</label>
    )
};
export default SubSpecialtyCard;